import { V4 } from '@moleculeone/utils';

export default class Repulsion {
  constructor(threshold, factor) {
    this.threshold = threshold;
    this.factor = factor;
  }

  apply(random, mol, forces) {
    const bonds = {};
    for (const bond of Object.values(mol.bonds)) {
      bonds[`${bond.start}-${bond.end}`] = true;
      bonds[`${bond.end}-${bond.start}`] = true;
    }

    const keys = Object.keys(mol.atoms);
    for (let i = 0; i < keys.length; i++) {
      const startIdx = keys[i];
      const startPos = mol.positions[startIdx];
      for (let j = 0; j < i; j++) {
        const endIdx = keys[j];
        const endPos = mol.positions[endIdx];
        let vector = V4.sub(endPos, startPos);
        let distance = V4.norm(vector);

        if (distance < 0.0001) {
          vector = V4.vect(random.quick() * 0.0001, random.quick() * 0.0001);
          distance = V4.norm(vector);
        }

        if (distance > this.threshold) {
          continue;
        }

        if (bonds[`${startIdx}-${endIdx}`] === true) {
          continue;
        }

        // f(x) = a/x + b
        // df/dx(threshold) = -1/100, a = threshold^2/100
        // f(threshold) = 0, b = -a/threshold = -threshold/100
        const a = (this.threshold * this.threshold) / 100;
        const b = -this.threshold / 100;
        const strength = a / distance + b;
        const force = V4.normal(vector, strength * this.factor);

        forces[startIdx].push(V4.scale(force, -1));
        forces[endIdx].push(force);
      }
    }
  }
}
